import { all } from "redux-saga/effects";

import loginSaga from "./login";
import logoutSaga from "./logout";
import resetQrSaga from "./resetQr";

export default function* authSaga() {
  yield all([loginSaga(), logoutSaga(), resetQrSaga()]);
}
